export default __webpack_public_path__ + "static/media/torso-low-front.85412ce2.png";